import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';

const NoteFilterComponent = ({ filterValue, setFilterValue, title }) => {
    const { t } = useTranslation();

    return (
        <FormControl fullWidth>
            <InputLabel id="filter-by">{title}</InputLabel>
            <Select
                fullWidth
                labelId="filter-by"
                value={filterValue}
                size="small"
                label={title}
                onChange={(e) => setFilterValue(e.target.value)}
            >
                {[
                    { value: 0, label: t('common.all') },
                    { value: 'yes', label: t('common.yes') },
                    { value: 'no', label: t('common.no') },
                ].map(({ value, label }) => (
                    <MenuItem value={value} key={value}>
                        {label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default NoteFilterComponent;
